export const LIST_OF_LINKS_MOCK_TEXT = {
  H1_FULL_TEXT: 'Lorem ipsum dolor',
  H2_FULL_TEXT: 'Vestibulum commodo vel risus ac dapibus. Mauris sollicitudin suscipit velit.',
  H1_SHORT_TEXT: 'Lorem ipsum',
  H2_SHORT_TEXT: 'Vestibulum commodo vel risus ac dapibus.',
};
